<template>
  <a-modal
    v-model="visibleAdd"
    class="modal"
    :maskClosable ="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">
        <a-form-model ref="ruleForm" :model="content" :rules="rules">
            <a-form-model-item ref="roleName" label="角色名称" prop="roleName">
                <a-input placeholder="请输入角色名称" v-model="content.roleName"/>
            </a-form-model-item>
            <a-form-model-item ref="roleType" label="角色类型" prop="roleType">
                <a-select
                        v-model="content.roleType"
                        placeholder="请输入角色类型"
                    >
                    <a-select-option v-for="item in usrRTList"
           
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      {{item.label}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item ref="roleStatus" label="角色状态" prop="roleStatus">
                <a-select
                        v-model="content.roleStatus"
                        placeholder="请输入角色状态"
                    >
                    <a-select-option v-for="item in usrRSList"
                   
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                      {{item.label}}
                    </a-select-option>
                    </a-select>
            </a-form-model-item>
            <a-form-model-item ref="roleOrder" label="顺序" prop="roleOrder" >
              <a-input-number placeholder="请输入顺序" v-model="content.roleOrder" class="input-number-order"/>
            </a-form-model-item>
            <a-form-model-item label="备注" prop="roleRemark" >
              <a-input v-model="content.roleRemark"   placeholder="请输入备注" type="textarea" />
            </a-form-model-item>
        </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button class="btaction" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import {
  addRoleData,
  updateRole,
  roleId
} from "@/api/api.js"
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  name: "roleAddModal",
  props: ["visible", "userData", "title", "type"],
  data() {
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (!Number.isInteger(value)) {
          return callback(new Error('请输入整数'));
        } else {
          if (value > 99999999) {
            return callback(new Error('顺序不能超过8位数'));
          } else {
            return callback();
          }
        }
      } else {
        return callback();
      }
    };
    return {
      //数据字典
      usrRTList: [],
      usrRSList: [],
      //参数
      content: {
        roleName: "",
        roleType: undefined,
        roleStatus: undefined,
        roleOrder: undefined,
        roleRemark: null,
        id:''
      },
      disabled: false,
      visibleAdd: this.visible,
      //校验规则
      rules: {
      roleName: [
          {
              required: true,
              message: "角色名称不能为空！",
              trigger: "blur",
          },{
            max: 100,
            message: '角色名称长度不能超过100'
          }
        ],
      roleType: [
        {
            required: true,
            message: "角色类型不能为空！",
            trigger: "blur",
        },
      ],
      roleStatus: [
        {
            required: true,
            message: "角色状态不能为空！",
            trigger: "blur",
        },
      ],
      roleRemark: [
        {
            max: 500,
            message: '备注长度不能超过500',
        },
      ],
      roleOrder: [
        {
          validator: checkAge,
          trigger: "change",
        }
      ],
      },
    };
  },
  created() {

    if (this.type == 'amend') {
      this.content.id = this.userData.id
      roleId({id:this.userData.id}).then((res) => {
        this.content.roleName = res.content.roleName
        this.content.roleType = res.content.roleType
        this.content.roleStatus = res.content.roleStatus
        this.content.roleOrder =parseInt(res.content.roleOrder) 
        this.content.roleRemark = res.content.remark
      })
    }
  },
  mounted() {
      //查询数据字典
      DictionaryService.getAllNeedDic(["ROLE_TYPE","ROLE_STATUS"]).then((res) => {
        this.usrRTList = DictionaryService.getOptions("ROLE_TYPE");
        this.usrRSList = DictionaryService.getOptions("ROLE_STATUS");
      });
  },
  methods: {
    handleOk(e) {//弹窗确定
    this.$refs.ruleForm.validate((valid) => {
      if (valid) {
        this.disabled = true;
        let pageParam = {
          pageNum: 0,
          pageSize: 0,
          orderBy: "",
        };
        if (this.type == "add") {
                addRoleData({
                    roleName: this.content.roleName,
                    roleType: this.content.roleType,
                    roleStatus: this.content.roleStatus,
                    roleOrder: this.content.roleOrder,
                    remark:this.content.roleRemark,
                })
                .then(
                    (res) => {
                        if (res.code == "0000") {
                            this.disabled = false;
                            this.success("新增成功");
                            this.$emit("close");
                            this.$emit("queryList");
                        }
                    },
                    (err) => {
                          this.disabled = false;
                    }
                );
            } else {
            updateRole({
                  id: this.content.id,
                  roleName: this.content.roleName,
                  roleType: this.content.roleType,
                  roleStatus: this.content.roleStatus,
                  roleOrder: this.content.roleOrder,
                  remark:this.content.roleRemark,
                }).then(
                    (res) => {
                        if (res.code == "0000") {
                            this.disabled = false;
                            this.success("修改成功");
                            this.$emit("close");
                            this.$emit("queryList");
                        }
                    },
                    (err) => {
                      this.disabled = false;
                    }
                );
            }
        }
      });
    },
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
      this.$refs["ruleForm"].resetFields();
    },
    success(title) {
      //提示
      this.$message.success(title, 3);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.message {
  width: 100%;
  height: auto;
  
  .ant-form-item{
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label{
    width: 120px;
  }
  /deep/ .ant-form-item-control{
    width: 350px;
  }
  /deep/ .input-number-order{
    width: 350px;
  }
}
</style>